<template>
  <el-row class="news-box pb-60 back">
    <el-row class="news-banner">
      <img :src="banner" />
      <lgy-container class="container">
        <p>新闻中心</p>
        <p>INFORMATION CENTER</p>
      </lgy-container>
    </el-row>
    <lgy-container class="pt-20">
      <el-row type="flex" justify="center" class="mt-20 mb-50">
        <el-col :span="6" class="align-center">
          <span
            class="btn"
            :class="[queryForm.type === 1 ? 'active' : '']"
            @click="search(1)"
          >
            平台新闻
          </span>
        </el-col>
        <el-col :span="6" class="align-center">
          <span
            class="btn"
            :class="[queryForm.type === 2 ? 'active' : '']"
            @click="search(2)"
          >
            行业动态
          </span>
        </el-col>
      </el-row>
      <el-row v-loading="loading" class="news-list">
        <el-row
          v-for="(item, index) in msgArr"
          :key="index"
          class="news-item"
          type="flex"
          :gutter="30"
        >
          <el-col class="left-img">
            <img :src="item.headImageUrl" />
          </el-col>
          <el-col class="right-msg">
            <p class="subject" @click="clickItem(item)">
              <span>
                {{ item.title }}
              </span>
            </p>
            <p class="content" v-html="item.description"></p>
            <el-row type="flex">
              <el-col class="align-left">
                <span>来源：</span>
                <span>{{ item.source }}</span>
              </el-col>
              <el-col class="align-right">
                <span>{{ item.createTime }}</span>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-row>
      <el-row>
        <el-col>
          <el-pagination
            class="align-right"
            background
            layout="prev, pager, next"
            :total="total"
          />
        </el-col>
      </el-row>
    </lgy-container>
  </el-row>
</template>

<script>
import api from '@/http/sys/information'
export default {
  data() {
    return {
      queryForm: {
        pageSize: 10,
        pageNum: 1,
        type: 1
      },
      loading: false,
      total: 0,
      banner: require('@/assets/img/xinwen.png'),
      msgArr: []
    }
  },
  created() {
    if (this.$route.query.type) {
      this.queryForm.type = parseInt(this.$route.query.type)
    }
    this.initData()
  },
  methods: {
    initData() {
      this.loading = true
      api.getListByPage(this.queryForm).then(
        res => {
          this.loading = false
          if (res.code === this.sucCode) {
            this.msgArr = res.rows
            this.total = res.total
          }
        },
        () => {
          this.loading = true
        }
      )
    },
    search(type) {
      this.queryForm.type = type
      this.queryForm.pageNum = 1
      this.initData()
    },
    clickItem(item) {
      this.$router.push({
        path: '/newsDetails',
        query: { id: item.id, type: this.queryForm.type }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.news-box {
  position: relative;
  min-height: 850px;
  background: $backColor;
  .btn {
    padding-bottom: 3px;
    font-size: 1.5rem;
    cursor: pointer;
  }
  .active {
    color: $primary;
    border-bottom: 4px solid $primary;
  }

  .news-banner {
    position: relative;
    .container {
      position: absolute;
      height: auto;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
      color: white;
      p {
        &:first-child {
          font-size: 1.875rem;
          font-weight: bold;
          margin-bottom: 0;
        }
        &:last-child {
          margin-top: 5px;
          font-size: 1.25rem;
        }
      }
    }
    img {
      height: 200px;
      width: 100%;
      min-width: 1200px;
    }
  }
}
.news-list {
  min-height: 700px;
  .news-item {
    height: 220px;
    // margin-bottom: 20px;
    padding: 20px 20px 30px;
    // border-top: 1px solid $borderColor;
    border-bottom: 1px solid $borderColor;
    .left-img {
      width: auto;
      img {
        width: 240px;
        height: 180px;
      }
    }
    .right-msg {
      width: calc(100% - 270px);
      .subject {
        margin-top: 6px;
        font-size: 1.5rem;
        cursor: pointer;
      }
      .content {
        width: 100%;
        height: 75px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 1rem;
        color: #828584;
      }
    }
    &:hover {
      .subject {
        color: $primary;
      }
    }
  }
}
</style>
